import React, { useEffect, useState } from "react";
import { ListCard, ListTable, PHARMACY_PAGE_SIZE } from "../common/ListScreen";
import { getTablePagination } from "../../../utils/tablePagination";
import { getPharmacyStockOutListApi } from "../../../services/pharmacyDashboard.services";
import { formatAmount } from "../common/money";

const columns = [
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Company", dataIndex: "company_name", key: "company_name" },
  { title: "Current Stock", dataIndex: "current_stock", key: "current_stock" },
  {
    title: "Packing",
    dataIndex: "packing",
    key: "packing",
    render: (value) => value ?? "-",
  },
  {
    title: "Rate",
    dataIndex: "rate_a",
    key: "rate_a",
    align: "right",
    render: (value) => formatAmount(value || 0),
  },
  {
    title: "Value",
    key: "value",
    align: "right",
    // Stock valued at the selling rate. Negative stock is a bookkeeping state,
    // not inventory worth money, so it values at zero rather than going negative.
    render: (_, record) =>
      formatAmount(
        Number(record?.rate_a || 0) *
          Math.max(0, Number(record?.current_stock || 0))
      ),
  },
  { title: "Stockout Limit", dataIndex: "stockout_limit", key: "stockout_limit" },
];

/*
 * `onLoaded` hands the response up to the screen above, which needs the
 * `tab_counts` block riding alongside it for the band. The table is already
 * asking for this list; asking a second time from up there was one call for
 * one answer too many.
 */
const StockOutTable = ({ onLoaded }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    const queryString = new URLSearchParams({ page, limit: PHARMACY_PAGE_SIZE });
    getPharmacyStockOutListApi(queryString)
      .then((res) => {
        setData(res?.data);
        onLoaded?.(res?.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const total = Number(data?.count) || 0;

  return (
    <ListCard
      title="Stock Out"
      count={total}
      range={{ page, pageSize: PHARMACY_PAGE_SIZE, total }}
    >
      <ListTable
        loading={loading}
        dataSource={data?.results || []}
        columns={columns}
        rowKey="id"
        pagination={getTablePagination({
          current: page,
          pageSize: PHARMACY_PAGE_SIZE,
          total,
          onChange: (p) => setPage(p),
        })}
      />
    </ListCard>
  );
};

export default StockOutTable;
